import React from 'react';
import { Popper, Paper, Grid, Skeleton } from '@mui/material';
import { INotificationFromStore } from 'shared/models/INotification.interface';
import NotificationsFromStore from './NotificationFromStore';
import NotificationsListEmpty from './NotificationsListEmpty';

interface INotificationsListProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  notifications: INotificationFromStore[] | null;
  notificationsAreAllRead: boolean;
  loading: boolean;
}

const NotificationsList = ({
  anchorEl,
  open,
  notifications,
  notificationsAreAllRead,
  loading,
}: INotificationsListProps) => (
  <Popper
    open={open}
    anchorEl={anchorEl}
    sx={{
      width: { xs: '80%', sm: '50%', md: '50%', lg: '25%' },
      zIndex: '1001',
      maxHeight: '70%',
      overflowY: 'auto',
      borderRadius: '8px',
      '&::-webkit-scrollbar': {
        width: '16px',
      },
      '&::-webkit-scrollbar-track': {
        borderRadius: '0px 8px 8px 0px',
        backgroundColor: (theme) => theme.palette?.state?.hover,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: (theme) => theme.palette.grey[400],
        borderRadius: '8px',
        border: '4px solid transparent',
        backgroundClip: 'padding-box',
      },
      boxShadow:
        'var(--ds-shadow-overlay, 0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31))',
    }}
    placement={'bottom-end'}
    id='notifications-from-store-popper'
  >
    <Paper
      sx={{
        background: (theme) => theme.palette?.state?.hover,
        p: 3,
        borderRadius: '8px 0px 0px 8px',
        border: '0px',
        width: '100%',
      }}
      data-testid='notification-panel'
    >
      {loading ? (
        <Grid container flexDirection='column' spacing={2}>
          {[1, 2, 3].map((index) => (
            <Grid item key={`notification-skeleton-${index}`}>
              <Skeleton width='100%' animation='wave' variant='rectangular' />
            </Grid>
          ))}
        </Grid>
      ) : (
        <>
          {notifications && notifications.length > 0 ? (
            <Grid
              container
              spacing={2}
              direction='column'
              id='notification-list'
            >
              {notifications.map((notification, key) => (
                <Grid
                  item
                  key={`notification-${key}`}
                  data-testid='notification-list'
                >
                  <NotificationsFromStore
                    notification={notification}
                    index={key}
                    notificationsAreAllRead={notificationsAreAllRead}
                  />
                </Grid>
              ))}
            </Grid>
          ) : (
            <NotificationsListEmpty />
          )}
        </>
      )}
    </Paper>
  </Popper>
);

export default NotificationsList;
